import { render, staticRenderFns } from "./AppLayoutV2.vue?vue&type=template&id=8e2cfbf0&scoped=true"
import script from "./AppLayoutV2.vue?vue&type=script&lang=js"
export * from "./AppLayoutV2.vue?vue&type=script&lang=js"
import style0 from "./AppLayoutV2.vue?vue&type=style&index=0&id=8e2cfbf0&prod&lang=css"
import style1 from "./AppLayoutV2.vue?vue&type=style&index=1&id=8e2cfbf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2cfbf0",
  null
  
)

export default component.exports